"use strict";
// File: types/Role.ts
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RolePermissionUpdateDTO = exports.RoleUpdateDTO = exports.RoleCreateDTO = exports.RoleGetDTO = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
class RoleGetDTO {
    static fromEntity(entity) {
        return (0, class_transformer_1.plainToClass)(RoleGetDTO, entity);
    }
    toPlain() {
        return (0, class_transformer_1.classToPlain)(this);
    }
}
exports.RoleGetDTO = RoleGetDTO;
class RoleCreateDTO {
    constructor() {
        this.isActive = true;
    }
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(RoleCreateDTO, plain);
    }
    toPlain() {
        const plain = (0, class_transformer_1.classToPlain)(this);
        // Add timestamps for creation
        plain.createdAt = new Date();
        plain.updatedAt = new Date();
        return plain;
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RoleCreateDTO.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RoleCreateDTO.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], RoleCreateDTO.prototype, "permissions", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], RoleCreateDTO.prototype, "permissionsMap", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], RoleCreateDTO.prototype, "isActive", void 0);
exports.RoleCreateDTO = RoleCreateDTO;
class RoleUpdateDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(RoleUpdateDTO, plain);
    }
    toPlain() {
        const plain = (0, class_transformer_1.classToPlain)(this);
        // Add updated timestamp
        plain.updatedAt = new Date();
        return plain;
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RoleUpdateDTO.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RoleUpdateDTO.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], RoleUpdateDTO.prototype, "permissions", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], RoleUpdateDTO.prototype, "permissionsMap", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], RoleUpdateDTO.prototype, "isActive", void 0);
exports.RoleUpdateDTO = RoleUpdateDTO;
class RolePermissionUpdateDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(RolePermissionUpdateDTO, plain);
    }
    toPlain() {
        const plain = (0, class_transformer_1.classToPlain)(this);
        plain.updatedAt = new Date();
        return plain;
    }
}
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], RolePermissionUpdateDTO.prototype, "permissions", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], RolePermissionUpdateDTO.prototype, "permissionsMap", void 0);
exports.RolePermissionUpdateDTO = RolePermissionUpdateDTO;
